import Animated, {Easing} from 'react-native-reanimated';

const {set, cond, startClock, stopClock, clockRunning, block, timing, debug, call, not, Value} = Animated;

export const runTiming = (
  clock: Animated.Clock,
  from: number,
  to: number,
  duration = 250,
  easing: Animated.EasingFunction = Easing.inOut(Easing.ease),
  callback: () => void = () => null,
) => {
  const state = {
    finished: new Value(0),
    position: new Value(0),
    time: new Value(0),
    frameTime: new Value(0),
  };

  const config = {
    duration: duration,
    toValue: new Value(0),
    easing: easing,
  };

  return block([
    cond(not(clockRunning(clock)), [
      set(state.finished, 0),
      set(state.time, 0),
      set(state.frameTime, 0),
      set(state.position, from),
      set(config.toValue, to),
      startClock(clock),
    ]),
    // @ts-ignore
    timing(clock, state, config),
    cond(state.finished, debug('stop clock', stopClock(clock))),
    cond(state.finished, call([state.position], callback)),
    state.position,
  ]);
};
